import React from 'react';
import { useSelector } from 'react-redux';
import { ContentSpacer } from '../../../global/components/layout/generic-content-spacer';
import { WysiwygWithReactLink } from '../../../global/components/wysiwyg-with-react-link';
import { headerIconStyles } from '../../../global/constants/theme/styles/components/header-icon-styles';
import { TcsmStates } from '../../../root/tcsm-model';
import { ClericIcon } from '../../account-info/components/cleric-indicator';
import { ClergyBioSettings } from '../../arc/models/arc-epi-props';


function EcdMessage() {
    const headerClasses = headerIconStyles();
    const settings = useSelector<TcsmStates, ClergyBioSettings>(state => state.epiProps?.clergyBioSettingsState?.epiContent);

    return (
        <>
            <ContentSpacer>
                <WysiwygWithReactLink content={settings?.aboutInfo} />
            </ContentSpacer>
            <div className={headerClasses.iconHeader}><ClericIcon/><p>{settings?.ecdHelperText}</p></div>
        </>
    );
}


export default EcdMessage;